import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=38cb70eb"
import script from "./EmptyLayout.js?vue&type=script&lang=js&external"
export * from "./EmptyLayout.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports